export default "__VITE_ASSET__tgobrYLx__"